/**************************************************
 * Nombre:       Tarjeta_Documentos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import YouTube from 'react-youtube';
import {FacebookShareButton, LinkedinShareButton, TwitterShareButton} from 'react-share';
import {compartirLink} from "../../Utilidades/compartirLink";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {Facebook, LinkedIn, Twitter} from "@mui/icons-material"
import {theme} from "../../Tema";


const Tarjeta_Documentos = ({item, escogida}) => {
    const {sCell, masSM} = useResponsive()

    const opts = {
        height: '180',
        width: '340',
        playerVars: {
            // https://developers.google.com/youtube/player_parameters
            autoplay: 0,

        },
    };

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={0}
            sx={{
                borderBottom: escogida === item.id ? 8 : 0,
                borderColor: theme.palette.primary.main,
                borderRadius: 0
            }}
        >


            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{
                justifyContent: sCell ? 'center' : 'flex-start',
            }}>
                {/*}  <img src={item.img ? item.img : img_video} width={'80%'} height={'auto'}/>*/}
                <YouTube videoId={item.link} opts={opts} style={{borderRadius: 40}}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 6}}
                  sx={{justifyContent: 'flex-start', px: sCell  ? 2 : 0, mt: !masSM ? 2 : 0}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontWeight: 600, fontSize: 24, lineHeight: 1.1}}>{item.nombre}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Typography sx={{
                            fontSize: 14,
                            textOverflow: "ellipsis",
                            display: '-webkit-box',
                            overflow: 'hidden',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 4
                        }}>
                            {item.descripcion}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'center', mt: 2, ml: -1.4}}>
                        <Grid
                            container
                            justifyContent={sCell ? 'flex-end' : 'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={0}>

                            {sCell ?
                                <Button
                                    onClick={() => compartirLink(item.link)}
                                    variant={'outlined'} sx={{fontSize: 12, width: 100}}>Compartir</Button>
                                :
                                <>
                                    <FacebookShareButton url={item.link}>
                                        <IconButton>
                                            <Facebook/>
                                        </IconButton>
                                    </FacebookShareButton>
                                    <TwitterShareButton url={item.link}>
                                        <IconButton>
                                            <Twitter/>
                                        </IconButton>
                                    </TwitterShareButton>
                                    <LinkedinShareButton url={item.link}>
                                        <IconButton>
                                            <LinkedIn/>
                                        </IconButton>
                                    </LinkedinShareButton>

                                </>

                            }


                        </Grid>

                    </Grid>

                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Documentos